module.exports = __webpack_public_path__ + "img/vipvip.811a91cc.png";